// ═══════════════════════════════════════════════════════════
// Loading 遮罩 — 带自动超时关闭
// ═══════════════════════════════════════════════════════════

import { TIMEOUT } from '../config/constants.js';
import { showToast } from './toast.js';

let loadingTimer = null;

export function showLoading(message = '加载中...') {
    if (loadingTimer) clearTimeout(loadingTimer);

    const loading = document.getElementById('loading');
    if (!loading) return;

    const msgEl = loading.querySelector('p');
    if (msgEl) msgEl.textContent = message;
    loading.style.display = 'flex';

    loadingTimer = setTimeout(() => {
        hideLoading();
        showToast('操作超时，请稍后重试', 'warning');
    }, TIMEOUT.LOADING_AUTO_DISMISS);
}

export function hideLoading() {
    if (loadingTimer) {
        clearTimeout(loadingTimer);
        loadingTimer = null;
    }

    const loading = document.getElementById('loading');
    if (loading) loading.style.display = 'none';
}

export default { showLoading, hideLoading };
